"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = require("prop-types");

require("./index.css");

var Toggle = function (_a) {
  var name = _a.name,
      dataTestId = _a.dataTestId,
      checked = _a.checked,
      children = _a.children,
      onClick = _a.onClick,
      disabled = _a.disabled;
  var isChecked = !!checked;
  var disabledClass = disabled ? 'disabled' : '';
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: "toggle-container"
  }, {
    children: [(0, jsx_runtime_1.jsx)("input", {
      id: name,
      name: name,
      type: "checkbox",
      "data-testid": dataTestId,
      onChange: function () {},
      checked: isChecked,
      disabled: disabled
    }, void 0), (0, jsx_runtime_1.jsxs)("label", __assign({
      className: "toggle-checkbox",
      htmlFor: name,
      role: name,
      "data-testid": dataTestId + "-label",
      onClick: function (e) {
        if (!disabled) {
          e.preventDefault();
          onClick();
        }
      },
      onKeyPress: function () {
        return onClick();
      },
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex: 0
    }, {
      children: [(0, jsx_runtime_1.jsx)("span", {
        className: "toggle-background " + disabledClass
      }, void 0), children && (0, jsx_runtime_1.jsx)("span", __assign({
        className: "toggle-label"
      }, {
        children: children
      }), void 0)]
    }), void 0)]
  }), void 0);
};

Toggle.propTypes = {
  name: prop_types_1.string.isRequired,
  dataTestId: prop_types_1.string,
  children: prop_types_1.node,
  checked: prop_types_1.bool,
  onClick: prop_types_1.func,
  disabled: prop_types_1.bool
};
Toggle.defaultProps = {
  checked: false,
  dataTestId: '',
  children: undefined,
  onClick: function () {},
  disabled: false
};
exports.default = Toggle;